// Количество звонков на одной странице таблицы истории звонков
export const ATS_CALLS_LIMIT = 10;

// Сообщение, которым API отвечает на отсутствие звонков у аккаунта
export const ATS_CALLS_NOT_FOUND_MESSAGE = 'Ошибка. Звонков не было найдено.';

// Имя файла записи звонка по умолчанию, если бэкенд не прислал оригинальное
export const ATS_RECORD_DEFAULT_FILE_NAME = 'call-record.mp3';

// Ключ localStorage с выбранной линией, с которой совершается исходящий звонок
export const ATS_CALL_FROM_KEY = 'atsCallFrom';

// Сообщение об ошибке загрузки списка линий для звонка
export const ATS_CALL_FROM_LOAD_ERROR_MESSAGE =
  'Не удалось загрузить список линий для звонка.';

// Сообщение, когда доступных линий для звонка нет
export const ATS_CALL_FROM_EMPTY_MESSAGE =
  'Нет доступных линий для звонка. Обратитесь к администратору.';

// Сообщение при попытке позвонить без выбранной линии
export const ATS_CALL_FROM_REQUIRED_MESSAGE =
  'Выберите линию, с которой совершить звонок';
